import { ACHIEVEMENTS, type AchievementDef } from '@/models/achievements';

export class AchievementManager {
  private counters: Record<string, number> = {};
  private unlocked: Set<string> = new Set();

  increment(counter: string, amount: number): AchievementDef[] {
    this.counters[counter] = (this.counters[counter] ?? 0) + amount;
    return this.checkUnlocks(counter);
  }

  private checkUnlocks(counter: string): AchievementDef[] {
    const newlyUnlocked: AchievementDef[] = [];
    for (const a of ACHIEVEMENTS) {
      if (a.counter !== counter) continue;
      if (this.unlocked.has(a.id)) continue;
      if ((this.counters[counter] ?? 0) >= a.target) {
        this.unlocked.add(a.id);
        newlyUnlocked.push(a);
      }
    }
    return newlyUnlocked;
  }

  getCounter(counter: string): number { return this.counters[counter] ?? 0; }
  getCounters(): Record<string, number> { return { ...this.counters }; }
  getUnlocked(): string[] { return [...this.unlocked]; }
  isUnlocked(id: string): boolean { return this.unlocked.has(id); }

  getProgress(id: string): { current: number; target: number; percent: number } {
    const def = ACHIEVEMENTS.find(a => a.id === id);
    if (!def) return { current: 0, target: 0, percent: 0 };
    const current = this.counters[def.counter] ?? 0;
    return { current, target: def.target, percent: Math.min(1, current / def.target) };
  }

  getTotalGemsEarned(): number {
    let total = 0;
    for (const id of this.unlocked) {
      const def = ACHIEVEMENTS.find(a => a.id === id);
      if (def) total += def.reward;
    }
    return total;
  }

  restoreState(counters: Record<string, number>, unlocked: string[]): void {
    this.counters = { ...counters };
    this.unlocked = new Set(unlocked);
  }
}
